<template>
  <div class="grid grid-cols-1 lg:grid-cols-3 w-full">
    <Block
      :primary-color="primaryColor"
      :secondary-color="white"
      :header="config.body?.block_one_header"
      :text="config.body?.block_one_text"
    />

    <Block
      :primary-color="white"
      :secondary-color="primaryColor"
      :header="config.body?.block_two_header"
      :text="config.body?.block_two_text"
    />

    <Block
      :primary-color="primaryColor"
      :secondary-color="white"
      :header="config.body?.block_three_header"
      :text="config.body?.block_three_text"
    />
  </div>
</template>

<script setup>
import Block from '@timon/js/Templates/LANDER-001/Components/Block.vue';
import {ref} from 'vue';

const props = defineProps({
  config: {
    type: Object,
    required: true,
  },
});

const primaryColor = ref(props.config.style?.primary);
const white = ref('ffffff');
</script>
